import { TradingGroupAccountModel, TradingGroupWithAccountsModel } from '@spa/api';

import { Helper } from 'appShared/classes';

export class PanelReportsTrait {
    static getAllSortedAccounts(groups: TradingGroupWithAccountsModel[]): TradingGroupAccountModel[] {
        const accounts = groups.reduce((
            groupedAccounts: TradingGroupAccountModel[],
            group: TradingGroupWithAccountsModel
        ) => {
            groupedAccounts.push(...group.accounts);

            return groupedAccounts;
        }, []);

        return Helper.sortingHelper().sortAccountsAlphabetically(accounts);
    }
}
